<div class="social-sidebar">
  <ul>
    <li><a target="_blank" href="https://www.facebook.com/bertrand.petit.58/">Facebook</a></li>
    <li><a target="_blank" href="https://twitter.com/BertrandPETIT5">Twitter</a></li>
    <li><a target="_blank" href="https://www.linkedin.com/in/bertrand-petit-a476741a7/">Linkedin</a></li>
  </ul>
</div>